import React, { useState } from 'react'
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import { Form, Modal } from 'react-bootstrap';
import { Link } from '@mui/material';
import { addreferral } from "../../Api/iron";
function ReferralView() {

    const [Fullname, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');

    const [validated, setValidated] = useState(false);
    const [errors, setErrors] = useState([]);
    const [apicall, setApicall] = useState(false);

    const handleSubmit = async (event) => {
        setApicall(true);
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setApicall(false);
        } else {
            event.preventDefault();
            const formdata = {
                fullname: Fullname,
                email: email,
                phone: phone
            }
            addreferral(formdata).then((res) => {
                console.log(res);
                if (!res.data.status) { setErrors(res.data.error); }
                else {
                    setApicall(false);
                    setValidated(false);
                    window.location.href = "/referrals";
                    return;
                }
            }).catch((err) => {
                alert(err);
            }).finally(() => {
                setApicall(false);
            });
        }
        setValidated(true);
    }

    return (
        <div>
            <div className="main-page-body-content-header">
                <HeaderAdmin />
            </div>
            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                            <h3>New Referrer</h3>
                                        </div>
                                        <div className="dashboard-sec">
                                            <div className="container-fulid">
                                                <div className="form-box-section mt-4">
                                                    <div className="form-box-inner">
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <label className="dashboard-form-lable">Name</label>
                                                                <input type="text"
                                                                    required
                                                                    className={`form-control dashboard-input-box-1 me-1`}
                                                                    placeholder="Name"
                                                                    name={"name"}
                                                                    onChange={(e) => setFullName(e.target.value)}
                                                                    value={Fullname}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <Form.Label className="dashboard-form-lable">Email</Form.Label>
                                                                <Form.Control
                                                                    type="email"
                                                                    className={`form-control dashboard-input-box-2`}
                                                                    placeholder="Email Address"
                                                                    name="email"
                                                                    onChange={(e) => setEmail(e.target.value)}
                                                                    value={email}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <label className="dashboard-form-lable">Phone</label>
                                                                <input
                                                                    type="number"
                                                                    name={"phone"}
                                                                    required
                                                                    onChange={(e) => setPhone(e.target.value)}
                                                                    value={phone}
                                                                    className={`form-control dashboard-input-box-2`}
                                                                    placeholder="Phone Number"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="sec-btn-group add_customer_btn mt-4">
                                                    {/* <Link to="/referrals"> */}
                                                        <button className="btn btn-cancel" type='button' onClick={
                                                            () => {
                                                                //navigate('/referrals');
                                                                window.location.href = "/referrals";
                                                            }
                                                        }>Exit without saving</button>
                                                    {/* </Link> */}
                                                    {apicall ? (
                                                        <button className="btn btn-save" disabled>Saving...</button>
                                                    ) : (<button className="btn btn-save" type="submit">Save new referrer</button>)}

                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    )
}

export default ReferralView